import { Stack } from '@mui/material';
import { NavLink } from 'react-router-dom';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { Button, Typography, Card } from '@occc/ui-design-system';

import { referralProgramDetailsMessages } from './referral-program-details.messages';

import { routeCreator } from '../../referral-program.router';

export const ReferralProgramNotConfiguredPage = () => {
  return (
    <Stack
      component={Card}
      justifyContent='center'
      alignItems='center'
      px={3}
      spacing={3}
      minHeight={300}
    >
      <Typography component='h2' variant='h4'>
        {referralProgramDetailsMessages.notConfiguredTitle}
      </Typography>
      <Typography>{referralProgramDetailsMessages.notConfiguredDescription}</Typography>
      <Button variant='contained' component={NavLink} to={routeCreator.configure()}>
        {referralProgramDetailsMessages.startConfigurationButtonText}
      </Button>
    </Stack>
  );
};
